export default "<p>\n  content-media works!\n</p>\n"